"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deleteNode = void 0;
const deleteNode = ({ httpClient, }) => ({ kubernetes_cluster_id, node_pool_id, node_id, drain_node = true, replace_node = false, }) => {
    const path = '/kubernetes/clusters';
    const url = `${path}/${kubernetes_cluster_id}/node_pools/${node_pool_id}/nodes/${node_id}`;
    const query_params = {
        replace: replace_node ? 1 : 0,
        skip_drain: drain_node ? 0 : 1,
    };
    return httpClient.delete(url, { params: query_params });
};
exports.deleteNode = deleteNode;
//# sourceMappingURL=delete-node.js.map